/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import Description from "App/model/description";
import {hexToRgbf} from "App/utils/utils";
import Serializer from "App/model/serializer";

import IScene from "js_interface/src/scene_interface";

//@ts-ignore we need the ts because otherwise the enum inside is not exported as tsx argue that no out is emmit for that file. We can use export const enum, but in this case tsc is ok with that, but on enum is exported at all
import {EBackgroundType} from "js_interface/src/modules/background/scene_background_enums.ts";

export
class ConfigurationData {

    //  tb todo remove this
    // background
    // public showSkybox: boolean = false;
    // public backgroundColor: number[] = hexToRgbf(0x8F8FCB); // default bkgrnd color
    // public backgroundType: EBackgroundType = EBackgroundType.COLOR; // this replaces showSkybox property
    // public backgroundImageName: string = "";
    // public backgroundImageFiType: number = 0;
    ///

    // view options
    /*public viewOptions: {
        compass: { enabled: boolean, tilt: boolean },
        axesCross: boolean,
        bbox: boolean,
        transparency: boolean,
        xray: boolean,
        outlines: boolean
    } = {
        compass: {enabled: true, tilt: true},
        axesCross: false,
        bbox: false,
        transparency: true,
        xray: false,
        outlines: true
    };*/

    /*, // this hardly rewrites fog settings from cookies
    public fog: {
        enabled: false,
        density: 6.0,
        distance: 80000.0,
        color: [0.0, 0.0, 1.0]
    }*/
}

export default
class Configuration {
    private _modelDescription: Description;
    private _sceneAPI: IScene;
    public settings: ConfigurationData = new ConfigurationData();

    constructor(aModelDescription: Description, aSceneAPI: IScene) {
        this._sceneAPI = aSceneAPI;
        this._modelDescription = aModelDescription;
    }

    public parse(aModelDescriptionJSON: any): boolean {

        if (!this._modelDescription.getRenderModel().getSceneAPIModel().getIsMainModel()) {
            return false;
        }

        if (!aModelDescriptionJSON.hasOwnProperty("ModelConfiguration")) {
            return false;
        }

        if (this._modelDescription.getRenderModel().getSceneAPIModel().getIsMainModel()) {
            this._sceneAPI.setModulesFromModelDescription(aModelDescriptionJSON);
        }

        return true;
    }

    public getProperties(): ConfigurationData {
        return Serializer.deepClone(this.settings);
    }

    public setProperties(aProperties: ConfigurationData) {
        this.settings = Serializer.deepClone(aProperties);
    }

    public getJSONRepresentation() {
        return this.getProperties();
    }

    public updateDOM() {
        let scripts = document.getElementsByTagName('script');
        for (let i = 0; i < scripts.length; i++) {
            let script = scripts[i];
            if (script.getAttribute("id") === "modelDescriptionFor_scene1") {
                // create json from content
                let contentJSON = JSON.parse(script.innerHTML);
                contentJSON.ModelConfiguration = this.getJSONRepresentation();
                script.innerHTML = JSON.stringify(contentJSON);
                return;
            }
        }
    }
}
